import prodConfig from './prod';
import devConfig from './dev';

export interface Config {
  readonly REACTION_TIMER: number;
  readonly SCREEN_SHARE_FPS: number;
  readonly MOUSE_SHARE_FPS: number;
  readonly SENTRY_DSN?: string;
  readonly SOCKET_BASE_URL: string;
  readonly BASE_URL: string;
  readonly API_BASE_URL: string;
  readonly MIN_CHROME_BROWSER: number;
  readonly VERSION: string;
  readonly COMMIT: string;
  readonly DEBUG: boolean;
  readonly APP_ENV: string;
  readonly GOOGLE_OAUTH_CLIENT_ID: string;
  readonly WHATSAPP_NUMBER: string;
  readonly SUPPORT_PHONE_NUMBER: string;
  readonly SALES_PHONE_NUMBER: string;
  readonly GTM_ID?: string;
  readonly GRADES: Array<{ label: string; value: string }>;
  readonly MIXPANEL_TOKEN: string;
  readonly DATA_PACKET_SIZE: number;
  readonly SUPPORT_EMAIL: string;
  readonly GOOGLE_BUSINESS_LINK: string;
  readonly BOT_USERNAME: string;
  readonly FIREBASE_CONFIG: object;
  readonly DATETIME_FORMAT: string;
  readonly OPHIR_PATH: string;
  readonly RECORDING_WEBHOOK_URL: string;
  readonly ADOBE_PDF_EMBED_KEY: string;
}

const defaultConfig: Config = {
  REACTION_TIMER: 2,
  SCREEN_SHARE_FPS: 12,
  MOUSE_SHARE_FPS: 18,
  BASE_URL: '',
  API_BASE_URL: '',
  SOCKET_BASE_URL: '',
  MIN_CHROME_BROWSER: 78,
  VERSION: 'unknown',
  COMMIT: 'unknown',
  DEBUG: false,
  APP_ENV: 'unknown',
  GOOGLE_OAUTH_CLIENT_ID: '',
  WHATSAPP_NUMBER: '+91 91509 33505',
  SUPPORT_PHONE_NUMBER: '+91 91509 33505',
  SALES_PHONE_NUMBER: '+91 82828 24825',
  GOOGLE_BUSINESS_LINK: 'https://g.page/r/CT-tfrrSuUwJEAg/review',
  GRADES: [
    { label: '3rd', value: '3' },
    { label: '4th', value: '4' },
    { label: '5th', value: '5' },
    { label: '6th', value: '6' },
    { label: '7th', value: '7' },
    { label: '8th', value: '8' },
    { label: '9th', value: '9' },
    { label: '10th', value: '10' },
    { label: 'Others', value: 'others' },
  ],
  MIXPANEL_TOKEN: '',
  DATA_PACKET_SIZE: 15000,
  SUPPORT_EMAIL: 'support@stayq.com',
  BOT_USERNAME: 'UwFi7B2WVTV-wHRd9GB-4VQ',
  FIREBASE_CONFIG: {},
  DATETIME_FORMAT: 'YYYY-MM-DDTHH:mm:ssZZ',
  OPHIR_PATH: 'https://wbo.ophir.dev/boards/StayQ',
  RECORDING_WEBHOOK_URL: '',
  ADOBE_PDF_EMBED_KEY: '',
};

var config: Config = defaultConfig;
const isProdLike =
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_ENV !== 'staging'; //this is set by cloudflare for staging
const isMockMode = process.env.REACT_APP_MOCK === 'true';

if (isProdLike) {
  config = {
    ...defaultConfig,
    ...prodConfig,
    VERSION: process.env.REACT_APP_RELEASE_VERSION || 'untagged',
    COMMIT: process.env.REACT_APP_RELEASE_COMMIT || 'untagged',
    APP_ENV: process.env.REACT_APP_ENV || 'production',
  };
} else {
  config = {
    ...defaultConfig,
    ...devConfig,
    VERSION: 'development',
    COMMIT: 'development',
    APP_ENV: isMockMode ? 'mock' : 'development',
    DEBUG: true,
  };
}

(window as any).SQCONFIG = config;

export default config;
